import { MULTI_PAYMENT_SCHEDULE_ACTION, PREVIEW_TABLE_HEADER } from './multi-payment-schedule-action'
import SINGLE_PAYMENT_SCHEDULE_ACTION from './single-payment-schedule-action'
export const LCS_DIALOG_LAYOUT_SETTING = {
  MULTI_PAYMENT_SCHEDULE_ACTION,
  PREVIEW_TABLE_HEADER,
  SINGLE_PAYMENT_SCHEDULE_ACTION
}
